module.exports = {"130183100":"晋州镇","130183101":"总十庄镇","130183102":"营里镇","130183103":"桃园镇","130183104":"东卓宿镇","130183105":"马于镇","130183106":"小樵镇","130183107":"槐树镇","130183108":"东里庄镇","130183201":"周家庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130183.json
// module id = 76
// module chunks = 0